import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCode,
  faFile,
  faFileDoc,
  faFileLines,
  faFilePdf,
  faFileSpreadsheet,
  faImage,
  faPresentationScreen,
  faText,
  faVideo,
  faVolume,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

export const MimeTypeIcon: React.FC<{
  mimeType?: string | undefined;
}> = ({ mimeType }): React.ReactElement => {
  let tooltip: string = "";
  let icon: IconDefinition = faFile;

  if (!mimeType) {
    icon = faFile;
    tooltip = "Unknown File Type";
  } else if (mimeType.startsWith("image/")) {
    icon = faImage;
    tooltip = "Image";
  } else if (mimeType.startsWith("video/")) {
    icon = faVideo;
    tooltip = "Video";
  } else if (mimeType.startsWith("audio/")) {
    icon = faVolume;
    tooltip = "Audio";
  } else if (mimeType.startsWith("application/")) {
    if (mimeType === "application/pdf") {
      icon = faFilePdf;
      tooltip = "PDF";
    } else if (mimeType === "application/vnd.google-apps.document") {
      icon = faFileDoc;
      tooltip = "Google Docs";
    } else if (mimeType === "application/vnd.google-apps.spreadsheet") {
      icon = faFileSpreadsheet;
      tooltip = "Google Sheets";
    } else if (mimeType === "application/vnd.google-apps.presentation") {
      icon = faPresentationScreen;
      tooltip = "Google Slides";
    } else {
      icon = faFile;
      tooltip = "Application File";
    }
  } else if (mimeType.startsWith("text/")) {
    if (mimeType === "text/html") {
      icon = faCode;
      tooltip = "HTML";
    } else if (mimeType === "text/plain") {
      icon = faText;
      tooltip = "Plain Text";
    } else {
      icon = faFileLines;
      tooltip = "Text Document";
    }
  }

  return (
    <Tooltip>
      <TooltipTrigger>
        <FontAwesomeIcon icon={icon} />
      </TooltipTrigger>
      <TooltipContent>
        {tooltip} <span className="text-foreground-4">({mimeType})</span>
      </TooltipContent>
    </Tooltip>
  );
};
